export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATEFOR5DISEASES_EN.50a91736.png";